import React from 'react';
import { Box, Typography, Divider, InputLabel, Select, MenuItem, FormControl, TextField } from "@mui/material";

export const InvoiceCreate = () => {
    return (

        <Box sx={{ width: '100%', padding: 1, marginTop: 2 }}>
            <Typography
                variant="h5"
                color="#4B5BD6"
                textAlign="start"
                sx={{ marginBottom: 1 }}
            >
                Fatura Oluştur
            </Typography>
            <Divider sx={{ marginBottom: 2 }} />
           
            <Box sx={{ backgroundColor: "#fff", padding: 3, borderRadius: 2, boxShadow: 2 }}>
                <Typography
                    variant="h6"
                    textAlign="left"
                    sx={{ marginBottom: 1, fontWeight: 'bold' }}
                >
                    Fatura Bilgileri
                </Typography>

                <Box sx={{ display: "flex", gap: 2 }}>
                    <FormControl fullWidth>
                        <InputLabel>Senaryo</InputLabel>
                        <Select
                            label="Senaryo"
                            defaultValue=""
                        >
                            <MenuItem value={1}>Senaryo 1</MenuItem>
                            <MenuItem value={2}>Senaryo 2</MenuItem>
                            <MenuItem value={3}>Senaryo 3</MenuItem>
                        </Select>
                    </FormControl>

                    <FormControl fullWidth>
                        <InputLabel>Fatura Tİp</InputLabel>
                        <Select
                            label="Fatura Tip"
                            defaultValue=""
                        >
                            <MenuItem value={1}>Satış</MenuItem>
                            <MenuItem value={2}>İade</MenuItem>
                            <MenuItem value={3}>İstisna</MenuItem>
                        </Select>
                    </FormControl>

                   
                    <FormControl fullWidth>
                        <InputLabel>Fatura Tip</InputLabel>
                        <Select
                            label="Fatura Tip"
                            defaultValue=""
                        >
                            <MenuItem value={1}>Türk Lirası</MenuItem>
                            <MenuItem value={2}>Euro</MenuItem>
                            <MenuItem value={3}>Dolar</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
            </Box>

            <Box sx={{ marginTop: 2, backgroundColor: "#fff", padding: 3, borderRadius: 2, boxShadow: 2, }}>
                <Typography
                    variant="h6"
                    textAlign="left"
                    sx={{ marginBottom: 1, fontWeight: 'bold' }}
                >
                    Fatura Kesilen Şirket/Kişi
                </Typography>

                <Box sx={{ display: "flex", gap: 4, marginBottom: 6 }}>
                    <FormControl fullWidth>
                        <TextField 
 size='small'

                            label="TC/VKN"
                            variant="standard"
                            sx={{ flex: 2 }}
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <TextField 
 size='small'

                            label="Kişi veya Firma Adı"
                            variant="standard"
                            sx={{ flex: 2 }}
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <TextField 
 size='small'

                            label="Soyadı"
                            variant="standard"
                            sx={{ flex: 2 }}
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <TextField 
 size='small'

                            label="E-posta"
                            variant="standard"
                            sx={{ flex: 2 }}
                        />
                    </FormControl>
                </Box>
                <Box sx={{ display: "flex", gap: 4, marginBottom: 6 }}>
                    <FormControl fullWidth>
                        <TextField 
 size='small'

                            label="Ülke"
                            variant="standard"
                            sx={{ flex: 2 }}
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <TextField 
 size='small'

                            label="Şehir"
                            variant="standard"
                            sx={{ flex: 2 }}
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <TextField 
 size='small'

                            label="Semt"
                            variant="standard"
                            sx={{ flex: 2 }}
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <TextField 
 size='small'

                            label="Cadde Adı"
                            variant="standard"
                            sx={{ flex: 2 }}
                        />
                    </FormControl>
                </Box>
                <Box sx={{ display: "flex", gap: 4, marginBottom: 6 }}>
                    <FormControl fullWidth>
                        <TextField 
 size='small'

                            label="Bina Adı"
                            variant="standard"
                            sx={{ flex: 2 }}
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <TextField 
 size='small'

                            label="Kapı Numarası"
                            variant="standard"
                            sx={{ flex: 2 }}
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <TextField 
 size='small'

                            label="Zip Code"
                            variant="standard"
                            sx={{ flex: 2 }}
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <TextField 
 size='small'

                            label="Telefon Numarası"
                            variant="standard"
                            sx={{ flex: 2 }}
                        />
                    </FormControl>
                </Box>
                <Box sx={{ display: "flex", gap: 4, marginBottom: 6 }}>
                    <FormControl fullWidth>
                        <TextField 
 size='small'

                            label="Fax Numarası"
                            variant="standard"
                            sx={{ flex: 2 }}
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <TextField 
 size='small'

                            label="Vergi Dairesi"
                            variant="standard"
                            sx={{ flex: 2 }}
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <TextField 
 size='small'

                            label="Web Sitesi"
                            variant="standard"
                            sx={{ flex: 2 }}
                        />
                    </FormControl>
                </Box>
            </Box>
            <Box sx={{ marginTop: 2, backgroundColor: "#fff", padding: 3, borderRadius: 2, boxShadow: 2, }}>
                <Typography
                    variant="h6"
                    textAlign="left"
                    sx={{ marginBottom: 1, fontWeight: 'bold' }}
                >
                    Fatura Kalemleri
                </Typography>


            </Box>
        </Box>
    );
};
